import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Index from './pages/Index';
import SearchResults from './pages/SearchResults';
import SiteDetail from './pages/SiteDetail';
import SimilarPage from './pages/SimilarPage';
import Categories from './pages/Categories';
import TopSites from './pages/TopSites';
import Compare from './pages/Compare';
import SubmitSite from './pages/SubmitSite';
import About from './pages/About';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Remove from './pages/Remove';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import NotFound from './pages/NotFound';
import { DefaultLocaleLayout, LocalePrefixLayout } from './components/LocaleLayout';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Default locale (no path prefix): /, /search, /blog, etc. */}
        <Route path="/" element={<DefaultLocaleLayout />}>
          <Route index element={<Index />} />
          <Route path="search" element={<SearchResults />} />
          <Route path="similar/:slug" element={<SimilarPage />} />
          <Route path="site/:slug" element={<SiteDetail />} />
          <Route path="categories" element={<Categories />} />
          <Route path="categories/:category" element={<Categories />} />
          <Route path="top-sites" element={<TopSites />} />
          <Route path="compare" element={<Compare />} />
          <Route path="submit" element={<SubmitSite />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="faq" element={<FAQ />} />
          <Route path="blog" element={<Blog />} />
          <Route path="blog/:slug" element={<BlogPost />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="terms" element={<Terms />} />
          <Route path="remove" element={<Remove />} />
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        {/* Locale-prefixed routes: /de, /de/search, /uk/blog, etc. */}
        <Route path="/:localePrefix" element={<LocalePrefixLayout />}>
          <Route index element={<Index />} />
          <Route path="search" element={<SearchResults />} />
          <Route path="similar/:slug" element={<SimilarPage />} />
          <Route path="site/:slug" element={<SiteDetail />} />
          <Route path="categories" element={<Categories />} />
          <Route path="categories/:category" element={<Categories />} />
          <Route path="top-sites" element={<TopSites />} />
          <Route path="compare" element={<Compare />} />
          <Route path="submit" element={<SubmitSite />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="faq" element={<FAQ />} />
          <Route path="blog" element={<Blog />} />
          <Route path="blog/:slug" element={<BlogPost />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="terms" element={<Terms />} />
          <Route path="remove" element={<Remove />} />
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
